module.exports = __webpack_public_path__ + "img/JD.3094172e.jpg";